import { UPLOAD_STATUS, VIDEO_UPLOADING_ACTIONS } from './constants';
import messages from './messages';
import { uploadVideoStatusTime } from './utils';

let uploadInitialTime;
let pollingInitialTime;

function trackTime(status, initialTime, fileLength, fileName) {
  if (!initialTime || !fileLength || !fileName) {
    return;
  }
  const currentTime = new Date().getTime();
  const elapsedTime = (currentTime - initialTime) / 1000;

  uploadVideoStatusTime(status, elapsedTime, fileLength, fileName);
}

function calculatePollingTime(hasSucceded, fileLength, fileName) {
  const status = hasSucceded ? 'polling_success' : 'polling_error';

  trackTime(status, pollingInitialTime, fileLength, fileName);
}

function calculateUploadTime(hasSucceded, fileLength, fileName) {
  const status = hasSucceded ? 'upload_success' : 'upload_error';

  trackTime(status, uploadInitialTime, fileLength, fileName);
}

export const getVimeoUploaderReducer = (intl) => (state, action) => {
  switch (action.type) {
    case VIDEO_UPLOADING_ACTIONS.CLOSE_SNACK_BAR:
      return { ...state, snackBarError: null };
    case VIDEO_UPLOADING_ACTIONS.SET_SNACK_BAR_ERROR:
      return { ...state, snackBarError: action.payload };
    case VIDEO_UPLOADING_ACTIONS.SET_CURRENT_UPLOAD_STATUS:
      return { ...state, currentUploadStatus: action.payload };
    case VIDEO_UPLOADING_ACTIONS.SET_FILE:
      uploadInitialTime = new Date().getTime();
      return { ...state, currentUploadStatus: UPLOAD_STATUS.UPLOADING, file: action.payload };
    case VIDEO_UPLOADING_ACTIONS.UPLOAD_ERROR:
      calculateUploadTime(false, state?.file?.size, state?.file?.name);
      return { ...state, currentUploadStatus: UPLOAD_STATUS.ERROR_UPLOADING, file: null };
    case VIDEO_UPLOADING_ACTIONS.POLLING:
      calculateUploadTime(true, state?.file?.size, state?.file?.name);
      pollingInitialTime = new Date().getTime();
      return { ...state, currentUploadStatus: UPLOAD_STATUS.POLLING };
    case VIDEO_UPLOADING_ACTIONS.POLLING_ERROR:
      calculatePollingTime(false, state?.file?.size, state?.file?.name);
      return {
        ...state,
        currentUploadStatus: UPLOAD_STATUS.ERROR_POLLING,
        file: null,
        snackBarError: intl.formatMessage(messages.errorUploadingTryAgain),
      };
    case VIDEO_UPLOADING_ACTIONS.POLLING_SUCCESS:
      calculatePollingTime(true, state?.file?.size, state?.file?.name);
      return { ...state, currentUploadStatus: UPLOAD_STATUS.UNSELECTED_FILE, file: null };
    default:
      throw new Error();
  }
};
